import React, { Fragment, useContext ,useState,useEffect} from "react";
import { Card, ProgressBar, OverlayTrigger, Tooltip ,Row, Col, Container} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faLightbulb, faUserCheck } from "@fortawesome/free-solid-svg-icons";

import "./App.css";
import { AppContext, UPDATE_STATE } from "../src/AppContext";
import { lazy, Suspense } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { forEach } from "lodash";
const RenderProjectBanner = lazy(() => import("./RenderProjectBanner"));
const RenderProjectLogo = lazy(() => import("./RenderProjectLogo"));

// Resources/Images/project_logo.png
const ProjectCard = ({
  hackthonProject,
  navigateDetails,
  hackthonProjectIds,
}) => {
  let location = useLocation();
  const [CurrentPath, setCurrentPath] = useState();
  const [data, dispatch] = useContext(AppContext);
  hackthonProject.isparticipant = false;
  hackthonProject.projectParticipants.forEach(element => {
    if (element.participantId == data.userid && element.status == "Submitted") {
      hackthonProject.isparticipant = true;
    }

  });
  
  //#region Calculating value for Prgressbar
  var TodaysDate = new Date();
  var TopicStartDdate = new Date(hackthonProject?.parentEventStartDate ? hackthonProject.parentEventStartDate : hackthonProject?.submissionStartdate);
  var TopicEndDate = new Date(hackthonProject?.parentEventEndDate ? hackthonProject.parentEventEndDate : hackthonProject?.submissionEnddate);


  var submissionTimeline = hackthonProject?.parentSessionTimelineProjects?.length
    ? hackthonProject.parentSessionTimelineProjects[1]
    : hackthonProject?.timelineProjects?.[1];
  var submissionEndDate = submissionTimeline?.endDate ? new Date(submissionTimeline.endDate) : null;
  if (submissionEndDate && TodaysDate > submissionEndDate) {
    hackthonProject.isSubmissionOver = true;
  } else {
    hackthonProject.isSubmissionOver = false;
  }

  // To calculate the time difference of two dates
  var Difference_In_Time =
    TopicStartDdate?.getTime() - TodaysDate?.getTime();
  var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));

  if (hackthonProject.ispublished) {
    hackthonProject.NoOfDays_Progressbar = "Winners Published";
    hackthonProject.Status_Progressbar = "closed";
  } else if (Difference_In_Days > 0) {
    // if Difference_In_Days is +ve , then event is in future
    hackthonProject.NoOfDays_Progressbar = Difference_In_Days;
    hackthonProject.Status_Progressbar = "Future";
    hackthonProject.Progressbar_val = Difference_In_Days;
  } else {
    // If Difference_In_Days is -ve,then event is inProgress then find the no.of days btw todays date and end date
    var Difference_In_Time =
      TopicEndDate?.getTime() - TodaysDate?.getTime();

    // To calculate the no. of days between two dates
    var Progressbar_val = Math.ceil(
      (1 -
        (TopicEndDate - TodaysDate) /
        (TopicEndDate - TopicStartDdate)) *
      100
    );
    Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));

    // Difference between the hours
    var diff = (TopicEndDate?.getTime() - TodaysDate?.getTime()) / 1000;
    diff /= 60 * 60;
    var time = Math.round(diff);
    //To display the final no. of days (result)
    if (time >= 0) {
      if (Difference_In_Days > 0) {
        hackthonProject.NoOfDays_Progressbar = Difference_In_Days;
        hackthonProject.Status_Progressbar = "Inprogress";
        hackthonProject.Progressbar_val = Progressbar_val;
      } else {
        if (hackthonProject.ispublished) {
          hackthonProject.NoOfDays_Progressbar = "Winners Published";
          hackthonProject.Status_Progressbar = "closed";
        } else {
          hackthonProject.NoOfDays_Progressbar = "Topic End Date Over";
          hackthonProject.Status_Progressbar = "closed";
        }
      }
    } else {
      if (Difference_In_Days > 0) {
        hackthonProject.NoOfDays_Progressbar = "today";
        hackthonProject.Status_Progressbar = "Today";
        hackthonProject.Progressbar_val = Progressbar_val;
      } else {
        if (hackthonProject.ispublished) {
          hackthonProject.NoOfDays_Progressbar = "Winners Published";
          hackthonProject.Status_Progressbar = "closed";
        } else {
          hackthonProject.NoOfDays_Progressbar = "Topic End Date Over";
          hackthonProject.Status_Progressbar = "closed";
        }
      }
    }
  }
  if (hackthonProject.projectParticipants.length > 0) {
  } else {
  }
  useEffect(() => {
const EventType = location.pathname;
  setCurrentPath(EventType)
  console.log("EventType",EventType)
  },[])
  //#endregion
  const navigate = (hackthonProject) => {
    // if(hackthonProject.Status_Progressbar != "closed")
    // {
    const currentIndex = hackthonProjectIds?.findIndex(
      (id) => id === hackthonProject.id
    );
    navigateDetails(hackthonProject.id, hackthonProjectIds, currentIndex);
    // }
  };

  return (
    <div>

        <Card
          className={hackthonProject.isparticipant  && CurrentPath=="/participant-topics"?
            "cardBorder card profile-card-2 h-100" : "card profile-card-2 h-100"}
          onClick={(e) => navigate(hackthonProject)}>

          {/* <span class="tooltiptext">Tooltip text</span> */}
          <div className="card-img-block">

            <Suspense fallback={<RenderProjectBanner projectId={null} />}>
              <RenderProjectBanner projectId={hackthonProject.id} />
            </Suspense>
          </div>
          <div className="card-body pt-4 jtWpRL">
            <div className="row">
              <div className="col-4">
                {/* <img src={projectLogo} alt="profile-image" className="profile" /> */}
                <Suspense fallback={<RenderProjectLogo projectId={null} />}>
                  <RenderProjectLogo projectId={hackthonProject.id} />
                </Suspense>
              </div>
              <div className="col-auto">
                <div className="ParticipanthomeRight-block ">
                  <span>
                    <FontAwesomeIcon icon={faUsers} />
                    {hackthonProject.numberOfParticipants}
                  </span>
                   <span>
                    <FontAwesomeIcon icon={faUserCheck} />
                    {hackthonProject.numberOfRegistered}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faLightbulb} />
                    {hackthonProject.numberOfSubmission}
                  </span>
                </div>
              </div>
            </div>
            <div className="kXwzQB">
              <h5 className="card-title card-title-font-bold">
                {hackthonProject.name}
              </h5>
              <p className="card-text trimmedDesc card-title-font">
                {hackthonProject.description}
              </p>
              <div className="tech-main card-title-font cRXOPc">
                {hackthonProject.projectSkills.map((element) => (
                  <span key={element?.id}>{element.skill?.skill1}</span>
                ))}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {/* <div className="sc-1oz6kez-7 dTsaSQ hZpvNA">
                        <div className="sc-1oz6kez-9 gNQDTQ">
                          <div className="sc-kuWgmH iutbio"> */}
                {/* <div className="sc-duSInm ggQpzy">
                              <div className="sc-jrrXlR jzPrPK"></div>
                            </div> */}
                {hackthonProject.Status_Progressbar == "Future" && (
                  <>
                    <ProgressBar
                      striped
                      variant="success"
                      now={hackthonProject.Progressbar_val}
                      className="mt-2"
                    />
                    {/* <div className="sc-crozmw kpLhIk card-title-font">
                      {hackthonProject.NoOfDays_Progressbar} &nbsp; days &nbsp; to
                      go
                     
                    </div> */}
                    <Row className="sc-crozmw kpLhIk card-title-font">
                     <Col > {hackthonProject.NoOfDays_Progressbar} &nbsp; days &nbsp; to
                      go</Col>
                      <Col className="alreadysubmitted">{hackthonProject.isparticipant && CurrentPath=="/participant-topics" && ("Already Submitted")}</Col>
                    </Row>
                    {hackthonProject.isSubmissionOver && (
                      <Row className="sc-crozmw kpLhIk card-title-font">
                        <Col>Submission Closed</Col>
                      </Row>
                    )}
                  </>
                )}
                {hackthonProject.Status_Progressbar == "Inprogress" && (
                  <>
                    <ProgressBar
                      striped
                      variant="warning"
                      now={hackthonProject.Progressbar_val}
                      className="mt-2"
                    />
                    <Row className="sc-crozmw kpLhIk card-title-font">
                     <Col > {hackthonProject.NoOfDays_Progressbar} &nbsp; days &nbsp; to
                      end{" "}</Col>
                      <Col className="alreadysubmitted">{hackthonProject.isparticipant && CurrentPath=="/participant-topics" && ("Already Submitted")}</Col>
                    </Row>
                    {hackthonProject.isSubmissionOver && (
                      <Row className="sc-crozmw kpLhIk card-title-font">
                        <Col>Submission Closed</Col>
                      </Row>
                    )}
                  </>
                )}
                {hackthonProject.Status_Progressbar == "Today" && (
                  <>
                    <ProgressBar
                      striped
                      variant="warning"
                      now={hackthonProject.Progressbar_val}
                      className="mt-2"
                    />
                    {/* <div className="sc-crozmw kpLhIk card-title-font">
                      {hackthonProject.NoOfDays_Progressbar} &nbsp; is the &nbsp;
                      last day{" "}
                    </div> */}
                    <Row className="sc-crozmw kpLhIk card-title-font">
                     <Col > {hackthonProject.NoOfDays_Progressbar} &nbsp; is the &nbsp;
                      last day{" "}</Col>
                      <Col className="alreadysubmitted">{hackthonProject.isparticipant && CurrentPath=="/participant-topics" && ("Already Submitted")}</Col>
                    </Row>
                    {hackthonProject.isSubmissionOver && (
                      <Row className="sc-crozmw kpLhIk card-title-font">
                        <Col>Submission Closed</Col>
                      </Row>
                    )}
                  </>
                )}

                {hackthonProject.Status_Progressbar == "closed" && (
                  <>
                    <ProgressBar striped now={0} className="mt-2" />
                    {/* <div className="sc-crozmw kpLhIk card-title-font">
                      {hackthonProject.NoOfDays_Progressbar}
                    </div> */}
                     <Row className="sc-crozmw kpLhIk card-title-font">
                     <Col >  {hackthonProject.NoOfDays_Progressbar}</Col>
                      <Col className="alreadysubmitted">{hackthonProject.isparticipant && CurrentPath=="/participant-topics" && ("Already Submitted")}</Col>
                    </Row>
                  </>
                )}
                
              </div>
            </div>
          </div>

        </Card>
      
    </div>

  );
};
export default ProjectCard;
